export default __webpack_public_path__ + "static/media/JosephSassoon.a66c63f4.jpg";